const screens = [
  {
    src: "/screens/IMG_8071.jpg",
    badge: "Home Screen",
    caption:
      "Your farms, herds and recent sessions in one place. Pick up where you left off in a single tap.",
    accent: "#2D4A22",
  },
  {
    src: "/screens/IMG_8081.jpg",
    badge: "Scanner Setup",
    caption:
      "Pair your Tru-Test, Gallagher or Zebra reader once, hit test, and you're ready. Bluetooth handled for you.",
    accent: "#5C2D91",
  },
  {
    src: "/screens/IMG_8072.jpg",
    badge: "Pick a Session Mode",
    caption:
      "Flip to Beef Mode or Dairy Mode, then pick from Register New Animals, Live Weight Draft, DNA, Herd Read or NAIT Snapshot — the workflow builds itself.",
    accent: "#D96C32",
  },
  {
    src: "/screens/IMG_8073.jpg",
    badge: "Animal Verification",
    caption:
      "Scan the EID and Arvo matches it against your system record instantly — VID, LID and EID confirmed before you record a thing.",
    accent: "#1F5BC1",
  },
  {
    src: "/screens/IMG_8155.jpg",
    badge: "Calving Ease",
    caption:
      "Log calving outcome in one tap: Unassisted, Easy Pull, Hard Pull, Surgical, Abnormal or Stillborn — colour-coded, dam-linked, done.",
    accent: "#0E6E66",
  },
  {
    src: "/screens/IMG_8074.jpg",
    badge: "Liveweight Recording",
    caption:
      "Auto-capture from your Bluetooth scale with a stable-weight indicator, or type it in — big numbers, big buttons, gloves-friendly.",
    accent: "#2D4A22",
  },
  {
    src: "/screens/IMG_8075.jpg",
    badge: "DNA Sampling",
    caption:
      "Type or scan the sample barcode, Arvo links it to the right animal with auto-validation — lab-ready CSV out at the end.",
    accent: "#5C2D91",
  },
  {
    src: "/screens/IMG_8080.jpg",
    badge: "Session Report",
    caption:
      "One clean Liveweight · Herd Read report at the end — scoring summary, match-rate donut, animal ID counters, animals-not-present list, and CSV exports ready to share.",
    accent: "#B83232",
  },
];

export default function AppShowcase() {
  const Card = ({ s, i }) => (
    <div
      data-testid={`app-screen-${s.badge.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="group bg-white border border-[#D5D1C8] rounded-md p-5 sm:p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all h-full flex flex-col"
    >
      <div
        className="relative rounded-md overflow-hidden"
        style={{ backgroundColor: "#0a0a0a" }}
      >
        <img
          src={s.src}
          alt={`${s.badge} — Arvo app screenshot`}
          loading="lazy"
          decoding="async"
          className="w-full h-auto block"
        />
      </div>
      <div className="mt-5">
        <span
          className="inline-block text-[10px] font-bold tracking-[0.2em] uppercase px-2.5 py-1 rounded-sm text-white"
          style={{ backgroundColor: s.accent }}
        >
          {`${String(i + 1).padStart(2, "0")} · ${s.badge}`}
        </span>
        <p className="mt-3 text-sm text-[#4A4F4A] leading-relaxed">
          {s.caption}
        </p>
      </div>
    </div>
  );

  return (
    <section
      id="app"
      data-testid="app-showcase-section"
      className="bg-[#F9F8F6] py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-[#D96C32]">
            Inside the App
          </span>
          <h2
            data-testid="app-showcase-headline"
            className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1A1D1A] leading-tight"
          >
            Real screens. Real workflows. Built for your phone.
          </h2>
          <p className="mt-5 text-lg text-[#4A4F4A] leading-relaxed">
            Big tap targets, plain words, and clear colour-coding so the right
            action is obvious — even with gloves on, even at the back of the
            yard.
          </p>
          <p
            data-testid="app-showcase-mobile-hint"
            className="mt-3 text-sm font-semibold text-[#2D4A22] sm:hidden"
          >
            ← Swipe to explore all {screens.length} screens →
          </p>
        </div>

        {/* Mobile: horizontal swipe carousel */}
        <div
          data-testid="app-showcase-carousel"
          className="mt-10 sm:hidden -mx-4 px-4 overflow-x-auto snap-x snap-mandatory scroll-smooth flex gap-4 pb-6"
          style={{ scrollbarWidth: "none" }}
        >
          {screens.map((s, i) => (
            <div
              key={s.badge}
              className="snap-center shrink-0 w-[82%] first:ml-0 last:mr-4"
            >
              <Card s={s} i={i} />
            </div>
          ))}
        </div>

        {/* Tablet/Desktop: grid */}
        <div className="mt-14 hidden sm:grid grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {screens.map((s, i) => (
            <Card key={s.badge} s={s} i={i} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#cta"
            data-testid="app-showcase-cta"
            className="inline-flex items-center gap-2 text-base font-bold text-[#2D4A22] hover:text-[#D96C32] transition-colors"
          >
            See it working in your yards →
          </a>
        </div>
      </div>
    </section>
  );
}
